import Modal from "@via/components/modal.tsx";
import { ModalSize } from "@via/utils/constants.tsx";
import { type FC } from "react";
import { useForm } from "react-hook-form";
import FormInputComponent from "@via/components/inputs/form-input-component";

interface InputValueModalProps {
  value: Record<string, unknown>;
  setValue: (value: Record<string, unknown> | null) => void;
  onSave: (inputId: string, value: string | null) => void;
}

interface FormData {
  value: string | null;
}

const InputValueModal: FC<InputValueModalProps> = ({
  value,
  setValue,
  onSave,
}) => {
  const { control, handleSubmit } = useForm<FormData>({
    mode: "onChange",
    defaultValues: {
      value: Object.values(value as Record<string, string>)[0] ?? null,
    },
  });

  // Resolving true hands the close to Modal. The parent's onSave used to close the
  // dialog itself, while this handler never settled at all.
  const handleConfirmModal = async (): Promise<boolean> => {
    let saved = false;
    await handleSubmit((payload: FormData) => {
      onSave(Object.keys(value)[0], payload.value);
      saved = true;
    })();
    return saved;
  };

  return (
    <>
      <Modal
        open={!!value}
        setOpen={() => setValue(null)}
        title="Edit Value"
        confirmText="Save"
        onConfirm={handleConfirmModal}
        size={ModalSize.Large}>
        <form onSubmit={e => e.preventDefault()}>
          <div className="my-5">
            <FormInputComponent control={control} name="value" label="Value" />
          </div>
        </form>
      </Modal>
    </>
  );
};

export default InputValueModal;
